import { RESPONSE_PAUSE_CODE, PLAYER_TYPE } from './enums'

/**
 * Coordinates all script playback.
 */

export default {
  state: {
    variableBuffer: {},
    flagEnums: {},
    currentFile: 'INIT.PAPSYS',
    initFile: 'INIT.PAPSYS',
    currentLineNum: 0,
    playerType: PLAYER_TYPE.AUTO_DIALOG,
  },
  mutations: {
    SET_CURRENT_FILE(state: any, fileName: string) {
      state.currentFile = fileName
    },
    SET_CURRENT_LINE(state: any, fileLine: number) {
      state.currentLineNum = fileLine
    },
    UPDATE_PLAYER_TYPE(state: any, playerType: PLAYER_TYPE) {
      state.playerType = playerType
    },
    VARIABLE_ADD(state: any, payload: any) {
      state.variableBuffer[payload.id] = payload.value
    },
    VARIABLE_ADD_FLAG(state: any, payload: any) {
      state.variableBuffer[payload.id] = payload.value
      state.flagEnums[payload.id] = payload.enums
    },
    VARIABLE_UPDATE(state: any, payload: any) {
      state.variableBuffer[payload.id] = payload.value
    },
  },
  actions: {
    async PROCESS_LINE(ctx: any) {
      if (!ctx.rootState.scripts.scriptBuffer.hasOwnProperty(ctx.state.currentFile)) {
        return {
          id: ctx.state.currentLineNum,
          code: RESPONSE_PAUSE_CODE.ERR_MISSING_SCRIPT,
          body: 'Script is missing',
        }
      }

      const currentScript = ctx.rootState.scripts.scriptBuffer[ctx.state.currentFile]
      const currentLine = currentScript[ctx.state.currentLineNum]

      // Only process valid rows as having three columns
      if (currentLine.length == 0) {
        return {
          id: ctx.state.currentLineNum,
          code: RESPONSE_PAUSE_CODE.EMPTY_LINE,
        }
      }

      // Macros are denoted by #'s.
      // Special character names are denoted by @'s.
      if (currentLine[0].startsWith('#')) {
        const macroName = currentLine[0].split(' ')[0].substring(1)
        const lastLineNum = ctx.state.currentLineNum

        switch (macroName) {
          case 'SCRIPTLOAD':
            console.log('SCRIPTLOAD to ' + currentLine[1], currentLine)
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.SCRIPT_LOAD,
              body: {
                name: currentLine[1].split('!')[0],
                content: await ctx.dispatch('M_SCRIPT_LOAD', { fileName: currentLine[1] }),
              },
            }
            break
          case 'JUMPFILE':
            console.log('JUMP-ing scripts to ' + currentLine[1])

            ctx.commit('SET_CURRENT_FILE', currentLine[1])
            ctx.commit('SET_CURRENT_LINE', 0)
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.SCRIPT_JUMP,
              body: {
                name: currentLine[1],
              },
            }
            break
          case 'JUMP':
            ctx.commit('SET_CURRENT_LINE', parseInt(currentLine[1]) - 1)
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.LINE_JUMP,
              body: parseInt(currentLine[1]),
            }
            break
          case 'PLAYERMODE':
            let nextType = PLAYER_TYPE.TWO_COLUMNS
            if (currentLine[1] == 'MANUAL') { nextType = PLAYER_TYPE.TWO_COLUMNS } else if (currentLine[1] == 'AUTO') { nextType = PLAYER_TYPE.AUTO_DIALOG }
            ctx.commit('UPDATE_PLAYER_TYPE', nextType)
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.PLAYER_CHANGE_TYPE,
              body: currentLine[1],
            }
            break
          case 'VOCABDEF':
            const vocab = {
              id: parseInt(currentLine[0].split(' ')[1]),
              term: currentLine[1].split(': ')[0] || '[nothing]',
              definition: currentLine[1].split(': ')[1] || '[nothing]',
            }
            ctx.commit('VOCAB_ADD_WORD', vocab)
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.VOCAB_DEFINE,
              body: vocab,
            }
            break
          case 'VOCABGET':
            ctx.commit('VOCAB_GET_WORD', parseInt(currentLine[1]))
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.VOCAB_GET,
              body: ctx.rootState.vocab.words[parseInt(currentLine[1])]
            }
          case 'DEFCHOICE':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.CHOICE_ADD_BUFFER,
              body: {
                value: currentLine[0].split(' ')[1],
                caption: currentLine[1],
              },
            }
            break
          case 'ASKCHOICE':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.PROMPT_ASK_CHOICE,
              body: {
                toVar: currentLine[0].split(' ')[1].split('$')[1],
              },
            }
            break
          case 'ENDSCRIPT':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.SCRIPT_END,
            }
            break
          case 'IF':
            // First variable - variable being compared
            // second variable - comparison factor
            // third variable - value being compared to
            // TODO: become more flexible
            const condStatement = currentLine[0].split(' ').slice(1)
            const comparedVariable = condStatement[0].split('$')[1]
            const comparedValue = condStatement[2]
            const resultantCommand = currentLine[1].split(' ')

            let result = false

            // STEP 1: EVALUATION
            if (condStatement[1] === 'IS') {
              console.log(comparedVariable, ctx.state.variableBuffer[comparedVariable], comparedValue)
              result = ctx.state.variableBuffer[comparedVariable] == comparedValue
            }

            // STEP 2: EXECUTION
            if (result) {
              // TODO: Shortcutting for now.. this should
              // later on be run by an interpretation function
              if (resultantCommand[0] == '#JUMP') {
                console.log(resultantCommand)
                ctx.commit('SET_CURRENT_LINE', parseInt(resultantCommand[1]) - 1)
              }
            }

            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.EVAL_CONDITIONAL,
              body: {
                result,
              },
            }
            break
          case 'TITLEADD':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.TITLE_ADD_BUFFER,
              body: {
                id: lastLineNum,      // TODO: remove this later
                class: currentLine[0].split(' ')[1],
                value: currentLine[1],
              },
            }
            break
          case 'TITLEPOP':      // TODO: handle options passed by script
          case 'TITLEPUSH':     // TODO: Deprecate 'TITLEPUSH'
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.TITLE_POP,
              // body: currentLine[1],
              body: {
                duration: 3000,
                trans_in: 1000,
                trans_out: 1000,
                bg: 'black',
                align: 'center',
              },
            }
            break
          case 'ASKSTR':              // TODO: move action away from Player.vue
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.PROMPT_ASK_STRING,
              body: {
                prompt: currentLine[1],
                toVar: currentLine[0].split(' ')[1].split('$')[1],
              },
            }
            break
          case 'CLEARLOG':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.LOG_CLEAR,
            }
            break
          case 'DEFSTR':
            ctx.commit('VARIABLE_ADD', {
              id: currentLine[0].split(' ')[1],
              value: currentLine[1],
            })
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.VARIABLE_DEFINE,
              body: {
                id: currentLine[0].split(' ')[1],
                value: currentLine[1],
              },
            }
            break
          case 'DEFFLG':
            ctx.commit('VARIABLE_ADD_FLAG', {
              id: currentLine[0].split(' ')[1],
              value: currentLine[1].split('; ')[0],
              enums: currentLine[1].split('; ')[1].split(', '),
            })
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.VARIABLE_DEFINE,
              body: {
                id: currentLine[0].split(' ')[1],
                value: currentLine[1].split('; ')[0],
                enums: currentLine[1].split('; ')[1].split(', '),
              },
            }
            break
          case 'SECTITLE':
          case 'COMMENT':
          case 'ENDIF':       // Need to rewrite this macro
          case 'SECDESC':
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.EMPTY_LINE,
            }
            break
          default:
            return {
              id: lastLineNum,
              code: RESPONSE_PAUSE_CODE.ERR_UNKNOWN_MACRO,
              body: `Unknown macro name ${macroName}.`,
            }
        }
      } else {
        const varRegex = /\$([A-Z]+)/g
        currentLine[1] = currentLine[1].replace(varRegex, (match: any) => {
          return ctx.state.variableBuffer[match.substring(1)] || `<${match}>`
        })
        return {
          id: ctx.state.currentLineNum,
          code: RESPONSE_PAUSE_CODE.DIALOGUE,
          body: currentLine,
        }
      }
    },
    NEXT_LINE(ctx: any) {
      // Process the next line.
      // Interprets it and updates all module states accordingly.
      ctx.commit('SET_CURRENT_LINE', ctx.state.currentLineNum + 1)
      return ctx.dispatch('PROCESS_LINE')
    },
  },
}
